webpackJsonp([1],{

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(895)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(899),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 892:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_services_pregao_server_time__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_components_base_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_components_base_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__default_components_base_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_helpers_LoteStatus__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_leiloes_services_pregao__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rogeriomenezes_comunicator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rogeriomenezes_comunicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rogeriomenezes_comunicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PregaoBotoes',
  extends: __WEBPACK_IMPORTED_MODULE_1__default_components_base_vue___default.a,
  data: function data() {
    return {
      processandoLance: false,
      errors: null,
      animFotos: [],
      animFotosIndex: 0,
      isComConnected: 0,
      leilao: {},
      pregao: null,
      lote: {
        numero: 0,
        imagem: null,
        descricao: '-',
        valorInicial: 0.00,
        valorIncremento: 0.00,
        valorMinimo: 0.00,
        valorMeta: 0.00,
        lancePrincipal: null,
        status: null,
        comitente: {
          pessoa: {}
        },
        pregao: null,
        lances: []
      },
      isLoading: false,
      centerContentFolded: false,
      hasNovoLance: false,
      countDownTimer: 10,
      defaultDownTimer: 10
    };
  },
  created: function created() {
    var _this = this;

    this.$loaderOverlay.open().message('Aguarde enquanto carregamos o leilão');
    __WEBPACK_IMPORTED_MODULE_4__domain_leiloes_services_pregao__["a" /* default */].find(this.$route.params.id).then(function (response) {
      _this.$loaderOverlay.hide();
      _this.isLoading = false;
      _this.leilao = response.data.leilao;

      _this.lote = response.data.lote;
      _this.pregao = response.data.pregao;
      if (_this.pregao !== null) {
        window.setTimeout(function () {
          _this.centerContentFolded = true;
          _this.carregaPregao();
        }, 500);
      }
    }).catch(function (response) {
      _this.$loaderOverlay.hide();

      window.responseError(response);
      console.log(response);
    });
  },

  computed: {
    proximoLote: function proximoLote() {
      if (!this.stats.proximoLote) {
        return null;
      }
      return this.stats.proximoLote;
    },

    filteredLances: function filteredLances() {
      var data = this.lote.lances;
      if (!Array.isArray(data)) {
        data = [];
      }

      data = data.slice().sort(function (a, b) {
        a = Number(a['valor']);
        b = Number(b['valor']);
        return (a === b ? 0 : a > b ? 1 : -1) * -1;
      });

      return data.slice(0, 5);
    },
    tituloLote: function tituloLote() {
      if (this.lote.tituloPregoeiro) {
        return this.lote.tituloPregoeiro.toUpperCase();
      } else if (this.lote.titulo) {
        return this.lote.titulo.toUpperCase();
      }
      return '';
    },
    descricaoLote: function descricaoLote() {
      if (this.lote.descricaoPregoeiro) {
        return this.lote.descricaoPregoeiro.toUpperCase();
      } else if (this.lote.descricao) {
        return this.lote.descricao.toUpperCase();
      }
      return '';
    },
    observacaoLote: function observacaoLote() {
      if (this.lote.observacaoPregoeiro) {
        return this.lote.observacaoPregoeiro.toUpperCase();
      } else if (this.lote.observacao) {
        return '';
      }
      return '';
    },
    totalLotes: function totalLotes() {
      if (typeof this.pregao === 'undefined' || this.pregao === null) {
        return 0;
      }
      return this.pregao.totalLotes;
    },
    totalSaldo: function totalSaldo() {
      if (typeof this.pregao === 'undefined' || this.pregao === null) {
        return 0;
      }
      return Number(this.pregao.totalLotes) - (Number(this.stats.retirados) + Number(this.stats.vendidos) + Number(this.stats.naoVendidos) + Number(this.stats.condicionais));
    },
    totalSaldoSucata: function totalSaldoSucata() {
      if (typeof this.pregao === 'undefined' || this.pregao === null) {
        return 0;
      }
      return Number(this.stats.saldoSucata);
    },
    percentualVenda: function percentualVenda() {
      if (!Number(this.stats.mediaFipe.valorVenda) && !Number(this.stats.mediaFipe.valorFipe)) return 0;
      return this.round(Number(this.stats.mediaFipe.valorVenda) * 100 / Number(this.stats.mediaFipe.valorFipe), 2);
    },
    percentualVendaAnterior: function percentualVendaAnterior() {
      if (!Number(this.stats.mediaFipeAnterior.valorVenda) && !Number(this.stats.mediaFipeAnterior.valorFipe)) return 0;
      return this.round(Number(this.stats.mediaFipeAnterior.valorVenda) * 100 / Number(this.stats.mediaFipeAnterior.valorFipe), 2);
    },
    comitenteNome: function comitenteNome() {
      if (this.lote.comitente === null) {
        return;
      }
      if (typeof this.lote.comitente.pessoa['nome'] === 'undefined') {
        return;
      }
      return this.lote.comitente.pessoa.nome.toUpperCase();
    },

    lanceLocalidade: function lanceLocalidade() {
      return this.testHasProperty() ? this.filteredLances[0].arrematante.pessoa.essencial.cidade + ' - ' + this.filteredLances[0].arrematante.pessoa.essencial.uf : '-';
    },
    lanceData: function lanceData() {
      return this.testHasProperty() ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.filteredLances[0].data.date).format('L') + ' - ' + __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.filteredLances[0].data.date).format('LTS') : '-';
    },
    valor: function valor() {
      return this.testHasProperty() ? this.filteredLances[0].valor : 0;
    },
    apelido: function apelido() {
      return this.testHasProperty() ? this.filteredLances[0].arrematante.apelido : '-';
    },
    compras: function compras() {
      return this.testHasProperty() ? this.filteredLances[0].arrematante.compras : null;
    },
    ultimaCompra: function ultimaCompra() {
      return this.testHasProperty() ? this.filteredLances[0].arrematante.ultimaCompra : null;
    },
    primeiraCompra: function primeiraCompra() {
      if (this.apelido === '-') {
        return false;
      }
      if (!this.compras) {
        return true;
      }
      if (!this.ultimaCompra && Number(this.compras) > 1) {
        return false;
      }
      var hoje = __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date()).format('DD/MM/YYYY');
      var ultimaCompra = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.ultimaCompra.date).format('DD/MM/YYYY');
      return hoje === ultimaCompra && Number(this.compras) <= 1;
    },
    timerPregao: function timerPregao() {
      if (typeof this.leilao['timerPregao'] === 'undefined') {
        return 10;
      }
      return parseInt(+this.leilao.timerPregao);
    },
    timerPregaoFormatado: function timerPregaoFormatado() {
      var timer = Number(this.countDownTimer);
      if (timer < 60) {
        return '00:' + ('0' + timer).slice(-2);
      }
      var hora = Math.floor(timer / 60);
      var minutos = timer % 60;
      return ('0' + hora).slice(-2) + ':' + ('0' + minutos).slice(-2);
    },
    Status: function Status() {
      return __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_helpers_LoteStatus__;
    },
    statusLote: function statusLote() {
      if (this.lote.status === null) {
        return '-';
      }
      if (typeof this.Status.Status[this.lote.status] !== 'undefined') {
        return this.Status.Status[this.lote.status].titulo;
      }
      return 'Status inválido';
    },
    colorStatus: function colorStatus() {
      if (this.lote.status === null) {
        return '#FFFFFF';
      }
      if (typeof this.Status.Status[this.lote.status]['color'] !== 'undefined') {
        return this.Status.Status[this.lote.status]['color'];
      }
      return '#FFFFFF';
    },
    porcentagemAvaliacao: function porcentagemAvaliacao() {
      var tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0;
      var avaliacao = typeof this.lote.valorAvaliacao !== 'undefined' ? this.lote.valorAvaliacao : 0;
      if (tabelaFipe > 0 && avaliacao > 0) {
        return this.round(avaliacao / tabelaFipe * 100, 2);
      }
      return 0;
    },
    porcentagemMinimo: function porcentagemMinimo() {
      var tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0;
      var minimo = typeof this.lote.valorMinimo !== 'undefined' ? this.lote.valorMinimo : 0;
      if (tabelaFipe > 0 && minimo > 0) {
        return this.round(minimo / tabelaFipe * 100, 2);
      }
      return 0;
    },
    minimoStyle: function minimoStyle() {
      return {
        'minimo-superado': Number(this.valor) >= Number(this.lote.valorMinimo)
      };
    },
    fipeLance: function fipeLance() {
      var tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0;
      var lance = Number(this.valor);
      if (tabelaFipe > 0 && lance > 0) {
        return this.round(lance / tabelaFipe * 100, 2) + '%';
      }
      return '0%';
    },
    classLanceOnline: function classLanceOnline() {
      if (typeof this.lote.lancePrincipal !== 'undefined' && this.lote.lancePrincipal !== null && this.lote.lancePrincipal !== 'null') {
        if (this.lote.lancePrincipal.arrematante.apelido !== 'PLATEIA') {
          return ['dash-pregao-online-leiloeiro'];
        }
        return [''];
      }
      return [''];
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.comunicator = __WEBPACK_IMPORTED_MODULE_5_rogeriomenezes_comunicator___default.a.connect("wss://ws.rogeriomenezes.com.br:8443/ws");
    this.comunicator.on('lance', this.onLance);
    this.comunicator.on('status', this.onStatus);
    this.comunicator.on('statusLeilao', this.onStatusLeilao);
    this.comunicator.on('tempo', this.onTempo);
    this.comunicator.on('mudaLote', this.onMudaLote);
    this.comunicator.on('lanceDeletado', this.onLanceDeletado);
    this.comunicator.on('alteracaoIncremento', this.onAlteracaoIncremento);
    this.comunicator.on('alteracaoTempo', this.onAlteracaoTempo);
    this.comunicator.on('comitenteDecisaoStatusLote', this.onComitenteDecisaoStatusLote);
    this.comunicator.on('com/connect', function (env) {
      _this2.isComConnected = 1;
    });
    this.comunicator.on('com/disconnect', function (env) {
      _this2.isComConnected = 2;
    });
    window.setTimeout(function () {
      if (_this2.isComConnected !== 1) {
        _this2.isComConnected = 2;
      }
    }, 4000);


    this._showMenu(false);
    this._showHeader(true);
    this._showFooter(false);
    this._menuFolded(false);
    this.$nextTick(function () {
      _this2.$root.$el.classList.add('full-height');
    });
  },
  destroyed: function destroyed() {
    console.log('Saindo da tela realtime');
    this.comunicator.close();
    this.$root.$el.classList.remove('full-height');
  },

  methods: {
    onLance: function onLance(data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return;
      }
      this.lote.lances.unshift(data.lote.lance);
      this.lote.lancePrincipal = this.filteredLances.length > 0 ? this.filteredLances.slice(0, 1).shift() : null;
      this.remoteNovoLance({
        id: data.lote.id,
        status: data.lote.status,
        lancePrincipal: data.lote.lance
      }, data.lote.lance);
    },
    onStatus: function onStatus(data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return;
      }
      delete this.lote.pregao;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(this.lote, data.lote);
      this.mountTimerCountdown();
    },
    onStatusLeilao: function onStatusLeilao(data) {
      if (!this.validateComunication(data)) {
        return;
      }
      if (data.status === 6) {
        this.carregaPregao();
      }
      this.leilao.status = data.status;
    },
    onTempo: function onTempo(data) {
      var _this3 = this;

      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return;
      }
      console.log('TEMPO!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!', data);
      this.lote.pregao.dataAbertura.date = data.lote.tempo.date;
      if (this.filteredLances.length > 0) {
        this.lote.lances[0].data = { date: data.lote.tempo };
      }
      this.$nextTick(function () {
        _this3.mountTimerCountdown();
      });
    },
    onMudaLote: function onMudaLote(data) {
      if (!this.validateComunication(data)) {
        return;
      }
      this.carregaPregao();
    },
    onLanceDeletado: function onLanceDeletado(data) {
      var _this4 = this;

      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return;
      }
      if (this.lote.lances.length === 0) {
        return;
      }
      for (var i = 0, len = this.lote.lances.length; i < len; ++i) {
        if (this.lote.lances[i].id === data.lote.lance) {
          this.lote.lances.splice(i, 1);
          break;
        }
      }
      this.$nextTick(function () {
        _this4.updateLancePrincipal();
      });
    },
    onAlteracaoIncremento: function onAlteracaoIncremento(data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return;
      }
      this.lote.valorIncremento = data.lote.incremento;
    },
    onAlteracaoTempo: function onAlteracaoTempo(data) {
      if (!this.validateComunication(data)) {
        return;
      }
      this.leilao.timerPregao = data.tempo;
      var that = this;
      this.$nextTick(function () {
        that.updateDefaultTimerPregao(that.leilao['timerPregao']);
        that.mountTimerCountdown();
      });
    },
    onComitenteDecisaoStatusLote: function onComitenteDecisaoStatusLote(data) {
      console.log(data);
    },
    validateComunication: function validateComunication(event) {
      if (typeof event['leilao'] === 'undefined') {
        return false;
      }
      if (typeof event['leilao']['id'] !== 'undefined') {
        return event['leilao']['id'] === this.leilao.id;
      }
      return event['leilao'] === this.leilao.id;
    },
    validateComunicationLote: function validateComunicationLote(event) {
      if (typeof event['lote'] === 'undefined') {
        return false;
      }
      if (typeof event.lote['id'] === 'undefined') {
        if (event.lote === this.lote.id) {
          return true;
        }
      } else {
        if (event.lote.id === this.lote.id) {
          return true;
        }
      }
      return false;
    },
    round: function round(number, precision) {
      var factor = Math.pow(10, precision);
      var tempNumber = number * factor;
      var roundedTempNumber = Math.round(tempNumber);
      return roundedTempNumber / factor;
    },
    testHasProperty: function testHasProperty() {
      return this.filteredLances.length > 0;
    },
    toggleKeyboard: function toggleKeyboard(v) {
      this.centerContentFolded = v;
    },

    reajustaTimerPregao: function reajustaTimerPregao(newTimer) {
      var _this5 = this;

      this.leilao.timerPregao = this.countDownTimer = newTimer;
      this.$nextTick(function () {
        _this5.mountTimerCountdown();
      });
      console.log('Reajustando timer do pregão');
    },
    carregaPregao: function carregaPregao() {
      var _this6 = this;

      var that = this;
      __WEBPACK_IMPORTED_MODULE_4__domain_leiloes_services_pregao__["a" /* default */].find(this.$route.params.id).then(function (response) {
        _this6.$loaderOverlay.hide();
        _this6.isLoading = false;
        _this6.leilao = response.data.leilao;

        _this6.lote = response.data.lote;
        _this6.pregao = response.data.pregao;
        if (_this6.pregao !== null) {
          window.setTimeout(function () {
            _this6.centerContentFolded = true;
            that.$nextTick(function () {
              if (typeof that.leilao['timerPregao'] !== 'undefined') {
                that.updateDefaultTimerPregao(that.leilao['timerPregao']);
                that.mountTimerCountdown();
              }
            });
          }, 500);
        }
        _this6.getStatsLeilao();
      }).catch(function (response) {
        _this6.$loaderOverlay.hide();

        window.responseError(response);
        console.log(response);
      });
    },
    getStatsLeilao: function getStatsLeilao() {
      window.setTimeout(function () {});
    },

    reset: function reset() {
      this.countDownTimer = this.defaultDownTimer;
    },
    updateDefaultTimerPregao: function updateDefaultTimerPregao(seconds) {
      this.defaultDownTimer = parseInt(seconds);
      this.countDownTimer = parseInt(seconds);
    },
    mountTimerCountdown: function mountTimerCountdown() {
      var that = this;
      this.$nextTick(function () {
        console.log('Countdown execute...');
        if (typeof this.$intervalCronometro !== 'undefined') {
          window.clearInterval(that.$intervalCronometro);
          that.reset();
        }
        if (typeof this.lote.pregao === 'undefined') {
          console.log('Lote não está em pregão, por isso não inicia o cronômetro.');
          return;
        }
        if (this.lote.pregao !== null) {
          console.log('Inicia os ajustes do cronômetro.', this.lote.pregao);

          var dataInicio = new Date(String(this.lote.pregao.dataAbertura.date).replace(/ /g, 'T'));

          if (this.lote.lances.length > 0) {
            var dataUltimoLance = new Date(this.lote.lances[0].data.date);
            if (dataUltimoLance.getTime() >= dataInicio.getTime()) {
              dataInicio = dataUltimoLance;
            }
          } else {}
          dataInicio.setSeconds(dataInicio.getSeconds() + this.timerPregao + 1);
          var intervalFcn = function intervalFcn() {
            var timeNow = void 0;
            if (__WEBPACK_IMPORTED_MODULE_0__utils_services_pregao_server_time__["a" /* serverTime */] > 0) {
              timeNow = __WEBPACK_IMPORTED_MODULE_0__utils_services_pregao_server_time__["b" /* timeNow */]();
            } else {
              timeNow = new Date().getTime();
            }
            var dataFim = timeNow;
            var distance = dataInicio.getTime() - dataFim;
            var seconds = Math.floor(distance / 1000);

            if (distance < 1) {
              window.clearInterval(that.$intervalCronometro);
              that.countDownTimer = 0;
            } else {
              that.countDownTimer = seconds;
            }
          };
          intervalFcn();
          this.$intervalCronometro = window.setInterval(intervalFcn, 1000);
        }
      });
    },
    updateLancePrincipal: function updateLancePrincipal() {},
    remoteNovoLance: function remoteNovoLance(lote, lance) {
      this.hasNovoLance = true;
      this.$nextTick(function () {
        var _this7 = this;

        window.setTimeout(function () {
          _this7.hasNovoLance = false;
        }, 100);
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(this.lote, lote);

      this.mountTimerCountdown();
    },
    calcPercentTimer: function calcPercentTimer(percent) {
      var downTimer = this.timerPregao;
      return downTimer * (percent / 100);
    },
    fcnTrocaFotos: function fcnTrocaFotos(fotoPrincipal, fotos) {
      var animFotos = [];

      for (var i = 0; i < fotos.length; i++) {
        animFotos.push({ active: false, image: fotos[i].url });
      }
      this.animFotos = animFotos;
      console.log(animFotos);
      this.startAnimFotos();
    },
    startAnimFotos: function startAnimFotos() {
      window.clearInterval(this._timerFotos);
      var that = this;
      this.animFotosIndex = 0;
      this._timerFotos = window.setInterval(function () {
        var next = that.animFotosIndex + 1;
        if (typeof that.animFotos[next] !== 'undefined') {
          that.lote.imagem = that.animFotos[next].image;
          that.animFotosIndex = that.animFotosIndex + 1;
        } else {
          that.lote.imagem = that.animFotos[0].image;
          that.animFotosIndex = 0;
        }
      }, 3000);
    },
    efetuarLance: function efetuarLance() {
      var _this8 = this;

      this.processandoLance = true;
      __WEBPACK_IMPORTED_MODULE_4__domain_leiloes_services_pregao__["a" /* default */].lancePlateia(this.$route.params.id, this.lote.id, 0, true).then(function (response) {
        _this8.processandoLance = false;
        _this8.errors = null;
      }).catch(function (response) {
        _this8.processandoLance = false;

        _this8.errors = response.data.errors;
        console.log(response);
      });
    },
    calculaPercentualVenda: function calculaPercentualVenda(v) {
      if (!Number(v.valorVenda) && !Number(v.valorFipe)) return 0;
      return this.round(Number(v.valorVenda) * 100 / Number(v.valorFipe), 2);
    }
  },
  components: {}
});

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(885)(true);
// imports


// module
exports.push([module.i, ".pregao-botoes{height:100vh;width:100%;padding:20px;background-color:#000;color:#fff}.pregao-botoes .header-info0{font-size:20px;text-align:center}.pregao-botoes .header-info0 .errors{margin-top:20px}.pregao-botoes .header-info0 .erros-content{color:darkred;height:60px}.pregao-botoes .buttons{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;width:100%}.pregao-botoes .buttons button{-ms-flex:1;flex:1;max-width:50%;height:100px;background-color:#3c3c3c}", "", {"version":3,"sources":["/opt/buildhome/repo/src/app/website/pregao-botoes/assets/scss/default.scss"],"names":[],"mappings":"AACA,eACE,aAAc,AACd,WAAY,AACZ,aAAc,AACd,sBAA0B,AAC1B,UAAe,CAChB,AACD,6BACI,eAAgB,AAChB,iBAAmB,CACtB,AACD,qCACM,eAAiB,CACtB,AACD,4CACM,cAAe,AACf,WAAa,CAClB,AACD,wBACI,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,0BAA2B,AACvB,qBAAsB,AAC1B,sBAAuB,AACnB,mBAAoB,AACxB,UAAY,CACf,AACD,+BACM,WAAY,AACR,OAAQ,AACZ,cAAe,AACf,aAAc,AACd,wBAA0B,CAC/B","file":"default.scss","sourcesContent":["\n.pregao-botoes {\n  height: 100vh;\n  width: 100%;\n  padding: 20px;\n  background-color: #000000;\n  color: #FFFFFF;\n}\n.pregao-botoes .header-info0 {\n    font-size: 20px;\n    text-align: center;\n}\n.pregao-botoes .header-info0 .errors {\n      margin-top: 20px;\n}\n.pregao-botoes .header-info0 .erros-content {\n      color: darkred;\n      height: 60px;\n}\n.pregao-botoes .buttons {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-line-pack: center;\n        align-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    width: 100%;\n}\n.pregao-botoes .buttons button {\n      -ms-flex: 1;\n          flex: 1;\n      max-width: 50%;\n      height: 100px;\n      background-color: #3C3C3C;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(893);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(886)("4293815d", content, true, {});

/***/ }),

/***/ 899:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full",
    class: _vm.classLanceOnline
  }, [_c('div', {
    staticClass: "pregao-botoes h-full",
    class: {
      'isLoading': _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "header-info0"
  }, [_c('div', {
    staticClass: "lote-num-label"
  }, [_c('div', {
    staticClass: "lote-numero"
  }, [_vm._v("Lote " + _vm._s(_vm.lote.numero)), _c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['enter']),
      expression: "['enter']"
    }],
    staticClass: "no-select",
    on: {
      "shortkey": _vm.efetuarLance
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "leilao-nome"
  }, [_vm._v(_vm._s(_vm.leilao.titulo))]), _vm._v(" "), _c('div', {
    staticClass: "errors"
  }, [_c('div', {
    staticClass: "erros-title"
  }, [_vm._v("Respostas/Erros")]), _vm._v(" "), _c('div', {
    staticClass: "erros-content"
  }, [_vm._v(_vm._s(_vm.errors))])])])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.processandoLance
    },
    on: {
      "click": _vm.efetuarLance
    }
  }, [(_vm.processandoLance) ? _c('span', [_vm._v("Processando lance...")]) : _c('span', [_vm._v("Lance")])])])])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.31bf4f9d0827ac10db1c.js